export const SEARCH = "SEARCH";
export const RESULTS_RECEIVED = "RESULTS_RECEIVED";
export const NO_DATA = "NO_DATA";
export const SUGGESTIONS_RECEIVED = "SUGGESTIONS_RECEIVED";
export const SUGGESTIONS_CLEARED = "SUGGESTIONS_CLEARED";
export const RESTAURANT_HOVER = "RESTAURANT_HOVER";
export const RESTAURANT_UNHOVER = "RESTAURANT_UNHOVER";
export const RESTAURANT_SELECT = "RESTAURANT_SELECT";
export const RESTAURANT_UNSELECT = "RESTAURANT_UNSELECT";
export const RESULTS_UPDATE = "RESULTS_UPDATE";
export const RESTAURANT_DELETE = "RESTAURANT_DELETE";
export const ADD_ALERT = "ADD_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const UPDATE_RESTAURANT = "UPDATE_RESTAURANT";
export const SELECT_CUISINE = "SELECT_CUISINE";
export const DESELECT_CUISINE = "DESELECT_CUISINE";
export const UPDATE_CUISINES = "UPDATE_CUISINES";

// AUTH
export const LOGIN_SUCCESS = "LOGIN_SUCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const UNAUTHENTICATE = "UNAUTHENTICATE";

// LOCATION
export const UPDATE_CURRENT_LOCATION = "UPDATE_CURRENT_LOCATION";
export const UPDATE_MAP_CENTER = "UPDATE_MAP_CENTER";
export const FETCH_LOCATION = "FETCH_LOCATION";
export const UPDATE_RADIUS = "UPDATE_RADIUS";
export const SET_LOCATION_DISPLAY = "SET_LOCATION_DISPLAY";

// RESULTS
export const MAP_VIEW = "MAP_VIEW";
export const LIST_VIEW = "LIST_VIEW";

// AD HOC SEARCH
export const START_AD_HOC_SEARCH = "START_AD_HOC_SEARCH";
export const ADD_AD_HOC_RESTAURANT = "ADD_AD_HOC_RESTAURANT";
export const SET_AD_HOC_SEARCH_STATUS = "SET_AD_HOC_SEARCH_STATUS";
export const PROMPT_FOR_MORE_BATCHES = "PROMPT_FOR_MORE_BATCHES";
export const STOP_AD_HOC_SEARCH = "STOP_AD_HOC_SEARCH";
export const AD_HOC_SEARCH_COMPLETE = "AD_HOC_SEARCH_COMPLETE";
export const CLEAR_AD_HOC_RESULTS = "CLEAR_AD_HOC_RESULTS";

// FILTERS
export const SET_MIN_LEAF_COUNT = "SET_MIN_LEAF_COUNT";
export const SET_VERIFICATION_TIER = "SET_VERIFICATION_TIER";
export const SET_KEYWORD_FILTER = "SET_KEYWORD_FILTER";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
